import { cn } from '@/lib/utils';
import { columnLabelClass } from '@/components/ui/typography.ts';
import { AcceptanceDocumentVm } from '@/features/dashboard/bookingChanges/types/ChangePackageFlowViewModel.ts';
import {
  documentsToSignLabel,
  skippedRecommendationLabel,
} from './acceptanceDocuments.ts';

interface AcceptanceDocumentListHeaderProps
  extends React.HTMLAttributes<HTMLDivElement> {
  documents: AcceptanceDocumentVm[];
  selectedIds: string[];
}

/** Nagłówek bloku dokumentów: co się dzieje z listą i co system podpowiada. */
const AcceptanceDocumentListHeader = ({
  documents,
  selectedIds,
  className,
  ...props
}: AcceptanceDocumentListHeaderProps) => {
  const skipped = skippedRecommendationLabel(documents, selectedIds);

  return (
    <div className={className} {...props}>
      <div className="flex flex-wrap items-baseline gap-x-2.5">
        <span className={columnLabelClass}>
          Dokumenty do ponownej akceptacji
        </span>
        <span className="text-[13px] text-neutral-500">
          {documentsToSignLabel(documents, selectedIds)}
        </span>
      </div>
      <p
        className={cn(
          'mt-1 text-pretty text-[13px]',
          skipped ? 'text-neutral-600' : 'text-neutral-500',
        )}
      >
        {skipped ??
          'Żaden dokument nie jest wymagany — system zaznacza te z szablonu i te wymagane przy zapisie.'}
      </p>
    </div>
  );
};

export default AcceptanceDocumentListHeader;
